import { gql } from "@apollo/client";

const createQuery = async (client, query, queryName, variables = {}) => {
  const { data } = await client.query({
    query,
    variables,
  });
  return data[queryName]?.data;
};

const GET_ALL_OPPORTUNITY = gql`
  query GetAllOpportunityForAdmin {
    getAllOpportunityForAdmin {
      response {
        status
        errMsg
        id_affected
      }
      data {
        id
        title
        description
        division_id
        location_id
        job_level
        is_open
        created_date
        created_by
        updated_date
        updated_by
        deleted_date
        deleted_by
        CandidateCount
        CountUnprocess
        CountProcess
        Location {
          id
          nama
        }
        Division {
          id
          division
        }
      }
    }
  }
`;

export const getAllOpportunityForAdmin = async (client) => {
  try {
    const allOpportunities = await createQuery(
      client,
      GET_ALL_OPPORTUNITY,
      "getAllOpportunityForAdmin",
      {}
    );
    return allOpportunities || [];
  } catch (error) {
    console.log(error);
    return [];
  }
};

const GET_OPPORTUNITY_BY_ID = gql`
  query GetOpportunityByID($getOpportunityByIdId: Int!) {
    getOpportunityByID(id: $getOpportunityByIdId) {
      data {
        id
        title
        description
        location_id
        division_id
        job_level
        is_open
        created_date
        created_by
        updated_date
        updated_by
        deleted_date
        deleted_by
        Location {
          id
          nama
        }
        Division {
          id
          division
        }
        Requirement {
          id
          opportunity_id
          job_requirement
        }
      }
    }
  }
`;

export const GetOpportunityByID = async (client, getOpportunityByIdId) => {
  try {
    const opportunityByID = await createQuery(
      client,
      GET_OPPORTUNITY_BY_ID,
      "getOpportunityByID",
      { getOpportunityByIdId }
    );

    return opportunityByID || [];
  } catch (error) {
    console.log(error);
    return [];
  }
};

const GET_MASTER_STATUS_ADMIN = gql`
  query GetMasterStatusAdmin {
    getMasterStatusAdmin {
      data {
        id
        status
      }
      response {
        status
        errMsg
        id_affected
      }
    }
  }
`;

export const getMasterStatusAdmin = async (client) => {
  try {
    const allStatusAdmin = await createQuery(
      client,
      GET_MASTER_STATUS_ADMIN,
      "getMasterStatusAdmin",
      {}
    );
    return allStatusAdmin || [];
  } catch (error) {
    console.log(error);
    return [];
  }
};

const GET_CANDIDATE_BY_OPPORTUNITY_ID = gql`
  query GetCandidatesByOpportunityID($getCandidatesByOpportunityIdId: Int!) {
    getCandidatesByOpportunityID(id: $getCandidatesByOpportunityIdId) {
      data {
        id
        email
        password
        full_name
        short_name
        link_photo
        phone_number
        address
        gender
        home_owner
        TotalPengalaman
        expected_benefits
        expected_salary
        curr_salary
        curr_benefits
        married_status
        birth_date
        birth_location
        ethnic
        nik
        sim
        sim_number
        blood
        home_phone_number
        height
        width
        link_cv
        skills
        status_hr_id
        mostest1
        mostest2
        cfit_score
        is_pre_assessment_done
        is_papikostik_done
        is_blacklist
        blacklist_reason
        psikotest_date
        created_date
        updated_date
        deleted_date
        deleted_by
        source_info
        Experiences {
          id
          candidate_id
          company
          job_position
          start_date
          end_date
          detail
          created_date
          created_by
          updated_date
          updated_by
          deleted_date
          deleted_by
          is_current
        }
        Courses {
          id
          candidate_id
          course_category
          course_organizer
          course_year
          created_date
          updated_date
          deleted_date
        }
        Educations {
          id
          candidate_id
          graduate_year
          major
          degree
          school_name
          created_date
          updated_date
          deleted_date
          is_current
        }
        Opportunity {
          id
          created_date
          updated_date
        }
        CFIT {
          iq
          result
        }
        PreAssessment {
          id
          candidate_id
          answer1
          answer2
          answer3
          answer4
          answer5
        }
        Papikostik {
          aspect
          candidate_id
          code
          created_date
          interpretation
          score
        }
      }
    }
  }
`;

export const getCandidatesByOpportunityID = async (
  client,
  getCandidatesByOpportunityIdId
) => {
  try {
    const getCandidateByOpID = await createQuery(
      client,
      GET_CANDIDATE_BY_OPPORTUNITY_ID,
      "getCandidatesByOpportunityID",
      {
        getCandidatesByOpportunityIdId,
      }
    );
    return getCandidateByOpID || [];
  } catch (error) {
    console.log(error);
    return [];
  }
};

const GET_LATEST_VERSION_ADMIN = gql`
  query GetLatestVersionAdmin {
    getLatestVersionAdmin {
      data {
        id
        version
        app
      }
      response {
        status
        errMsg
        id_affected
      }
    }
  }
`;

export const getLatestVersionAdmin = async (client) => {
  try {
    const getAllLatestVersionAdmin = await createQuery(
      client,
      GET_LATEST_VERSION_ADMIN,
      "getLatestVersionAdmin",
      {}
    );
    return getAllLatestVersionAdmin || [];
  } catch (error) {
    console.log(error);
    return [];
  }
};

const GET_DIVISION = gql`
  query GetMasterDivision {
    getMasterDivision {
      data {
        id
        division
      }
      response {
        status
        errMsg
        id_affected
      }
    }
  }
`;

export const getMasterDivision = async (client) => {
  try {
    const masterDivision = await createQuery(
      client,
      GET_DIVISION,
      "getMasterDivision",
      {}
    );
    return masterDivision || [];
  } catch (error) {
    console.log(error);
    return [];
  }
};

const GET_MASTER_KOTA = gql`
  query GetMasterKota {
    getMasterKota {
      response {
        status
        errMsg
        id_affected
      }
      data {
        id
        nama
      }
    }
  }
`;

export const getMasterKota = async (client) => {
  try {
    const masterKota = await createQuery(
      client,
      GET_MASTER_KOTA,
      "getMasterKota",
      {}
    );
    return masterKota || [];
  } catch (error) {
    console.log(error);
    return [];
  }
};

const GET_MASTER_INTERVIEW_LOCATION = gql`
  query GetMasterLokasiInterview {
    getMasterLokasiInterview {
      data {
        id
        nama
        alamat
        created_date
        updated_date
        deleted_date
      }
      response {
        status
        errMsg
        id_affected
      }
    }
  }
`;

export const getMasterLokasiInterview = async (client) => {
  try {
    const locInterview = await createQuery(
      client,
      GET_MASTER_INTERVIEW_LOCATION,
      "getMasterLokasiInterview",
      {}
    );
    return locInterview || [];
  } catch (error) {
    return { errMsg: { error } };
  }
};

const GET_MASTER_CLINIC = gql`
query GetMasterClinic {
  getMasterClinic {
    data {
      id
      clinic_name
      clinic_branch
      clinic_address
      telp_number
      created_date
      updated_date
      deleted_date
      detailClinic {
        id
        clinic_id
        cabang
        clinic_email
        create_by
        update_by
        create_date
        updated_date
        deleted_date
      }
    }
    response {
      status
      errMsg
      id_affected
    }
  }
} 
`;

export const getMasterClinic = async (client) => {
  try {
    const masterClinic = await createQuery(
      client,
      GET_MASTER_CLINIC,
      "getMasterClinic",
      {}
    );
    return masterClinic || [];
  } catch (error) {
    return { errMsg: { error } };
  }
};

const GET_COUNT_CANDIDATE_EACH_STATUS = gql`
  query GetCountCandidateEachStatus {
    getCountCandidateEachStatus {
      data {
        id
        status
        count
      }
      response {
        status
        errMsg
        id_affected
      }
    }
  }
`;

export const GetCountCandidateEachStatus = async (client) => {
  try {
    const candidateEachStatus = await createQuery(
      client,
      GET_COUNT_CANDIDATE_EACH_STATUS,
      "getCountCandidateEachStatus",
      {}
    );
    return candidateEachStatus || [];
  } catch (error) {
    console.log(error);
    return [];
  }
};
const GET_CANDIDATE_BY_ID = gql`
  query GetCandidateByID($getCandidateByIdId: Int) {
    getCandidateByID(id: $getCandidateByIdId) {
      data {
        id
        email
        password
        full_name
        short_name
        link_photo
        phone_number
        address
        gender
        home_owner
        TotalPengalaman
        married_status
        birth_date
        birth_location
        ethnic
        expected_benefits
        expected_salary
        curr_salary
        curr_benefits
        nik
        sim
        sim_number
        home_phone_number
        blood
        height
        width
        link_cv
        skills
        cfit_score
        is_pre_assessment_done
        is_blacklist
        blacklist_reason
        psikotest_date
        medical_checkup_date
        cfit_section_1_date
        cfit_section_2_date
        cfit_section_3_date
        cfit_section_4_date
        cfit_second_remaining
        created_date
        updated_date
        deleted_date
        deleted_by
        status_hr_id
        source_info
        Experiences {
          id
          candidate_id
          company
          job_position
          start_date
          end_date
          detail
          created_date
          created_by
          updated_date
          updated_by
          deleted_date
          deleted_by
          is_current
        }
        Courses {
          id
          candidate_id
          course_category
          course_organizer
          course_year
          created_date
          updated_date
          deleted_date
        }
        Educations {
          id
          candidate_id
          degree
          graduate_year
          major
          school_name
          created_date
          updated_date
          deleted_date
          is_current
          start_year
        }
        CFIT {
          iq
          result
        }
        PreAssessment {
          id
          candidate_id
          answer2
          answer1
          answer3
          answer4
          answer5
          created_date
        }
        Papikostik {
          id
          candidate_id
          code
          aspect
          score
          interpretation
          created_date
          updated_date
        }
        interview_hr_date
        interview_user_date
      }
    }
  }
`;

export const GetCandidateByID = async (client, getCandidateByIdId) => {
  try {
    const dataCandidate = await createQuery(
      client,
      GET_CANDIDATE_BY_ID,
      "getCandidateByID",
      { getCandidateByIdId }
    );
    return dataCandidate || [];
  } catch (error) {
    console.log(error);
    return [];
  }
};

const GET_CALENDAR_INVITATION = gql`
query GetCalendarInvitation($opportunityId: Int!) {
  getCalendarInvitation(opportunity_id: $opportunityId) {
    data {
      id
      candidate_id
      status_hr_id
      link_attachment
      created_date
      status
      CandidateDetail {
        id
        full_name
        psikotest_date
        medical_checkup_date
        interview_hr_date
        interview_user_date
        link_meet_interview
        link_meet_psikotest
        technical_test_due_date
        attachment_technical_test
      }
    }
    response {
      status
      errMsg
      id_affected
    }
  }
}`

export const getCalendarInvitation = async (client, opportunityId) => {
  try {
    const calendarInvitation = await createQuery(
      client,
      GET_CALENDAR_INVITATION,
      "getCalendarInvitation",
      { opportunityId }
    )
    return calendarInvitation || [];
  } catch (error) {
    console.log(error);
    return []
  }
}

const GET_MASTER_SKILLS = gql`
  query GetMasterSkill {
    getMasterSkill {
      data {
        id
        skill
      }
      response {
        status
        errMsg
        id_affected
      }
    }
  }
`;

export const GetMasterSkill = async (client) => {
  try {
    const dataMasterSkills = await createQuery(
      client,
      GET_MASTER_SKILLS,
      "getMasterSkill",
      {}
    );
    return dataMasterSkills || [];
  } catch (error) {
    console.log(error);
    return [];
  }
};

const GET_RESULT_CANDIDATE = gql`
query GetCandidateRecruitmentResult($candidateId: Int!, $opportunityId: Int!) {
  getCandidateRecruitmentResult(candidate_id: $candidateId, opportunity_id: $opportunityId) {
    data {
      id
      candidate_id
      status_hr_id
      status
      opportunity_id
      result
      remarks
      date_process
      link_attachment
      created_date
      updated_date
      deleted_date
    }
    response {
      status
      errMsg
      id_affected
    }
  }
}`

export const GetCandidateRecruitmentResult = async (client, candidateId, opportunityId) => {
  try {
    const resultCandidate = await createQuery(
      client,
      GET_RESULT_CANDIDATE,
      "getCandidateRecruitmentResult",
      {
        candidateId,
        opportunityId
      }
    )
    return resultCandidate || []
  } catch (error) {
    console.log(error, "ERROR GET RESULT CANDIDATE")
    return []
  }
}

const GET_ALL_ACTIVE_LANDING_PAGE = gql`
query GetAllActiveLandingPage {
  getAllActiveLandingPage {
    data {
      id
      link_media
      deskripsi
      is_open
    }
    response {
      status
      errMsg
      id_affected
    }
  }
}
`

export const GetActiveLandingPage = async (client) => {
  try {
    const landingPage = await createQuery(
      client,
      GET_ALL_ACTIVE_LANDING_PAGE,
      "getAllActiveLandingPage",
      {}
    )
    return landingPage || []
  } catch (error) {
    console.log(error, "ERROR GET LANDING PAGE")
    return []
  }
}

const GET_ALL_LANDING_PAGE_ADMIN = gql`
query GetAllLandingPageForAdmin {
  getAllLandingPageForAdmin {
    data {
      link_media
      deskripsi
      is_open
      created_date
      created_by
      updated_date
      updated_by
      id
    }
    response {
      status
      errMsg
      id_affected
    }
  }
}
`

export const GetLandingPageAdmin = async (client) => {
  try {
    const landingPage = await createQuery(
      client,
      GET_ALL_LANDING_PAGE_ADMIN,
      "getAllLandingPageForAdmin",
      {}
    )
    return landingPage || []
  } catch (error) {
    console.log(error, "ERROR GET LANDING PAGE")
    return []
  }
}
